import { z } from "zod/v4";

import { AgenticLogicMetafieldRefDescriptions } from "../../../descriptions/agentic-logic.describe";
import { assertDescriptions } from "../../../descriptions/types";

// ---------------------------------------------------------------------------
// Metafield addressing — the shared (namespace, key) pair.
//
// Deliberately its own module: three unrelated consumers extend or embed it —
// the post-fetch metafield predicate, the `include.metafields` projection on a
// product query, and the resolved `AgenticLogicProductMetafield` on a product page.
// ---------------------------------------------------------------------------

export const AgenticLogicMetafieldRefSchema = z
  .object({
    namespace: z
      .string()
      .describe(AgenticLogicMetafieldRefDescriptions.namespace),
    key: z.string().describe(AgenticLogicMetafieldRefDescriptions.key),
  })
  .describe(AgenticLogicMetafieldRefDescriptions._schema);
export type AgenticLogicMetafieldRef = z.infer<
  typeof AgenticLogicMetafieldRefSchema
>;

assertDescriptions<
  typeof AgenticLogicMetafieldRefDescriptions,
  AgenticLogicMetafieldRef
>();
